import React from 'react'

export function useInterval(fn: () => void, interval: number) {
	React.useEffect(() => {
		const timer = setInterval(fn, interval)

		return () => clearInterval(timer)
	}, [])
}